export const SELECT_ANIMAL_TYPE = 'SELECT_ANIMAL_TYPE'
export const SELECT_IS_GOOD_WITH_CHILDREN = 'SELECT_IS_GOOD_WITH_CHILDREN'
export const SELECT_AGE = 'SELECT_AGE'
export const SELECT_GENDER = 'SELECT_GENDER'
export const SELECT_SIZE = 'SELECT_SIZE'
export const SELECT_PETFINDER_API = 'SELECT_PETFINDER_API'
export const LOAD_PETS = 'LOAD_PETS'
export const PET_ADOPT = 'PET_ADOPT'
export const SELECTED_PET = 'SELECTED_PET'
